export default "__VITE_ASSET__BU6XnZxj__"